<template>
  <!--<div :class="'form-wizard-steps form-wizard-tolal-steps-' + (steps.length)">-->
  <!--  <b-progress :value="value" :max="steps.length-1" class="mb-3 nav-progress"></b-progress>-->
  <!--  <div :class="'form-wizard-step ' + (index <= value ? 'active':'')" v-for="(step, index) in steps" :key="index" @click="goStep(index)">-->
  <!--    <div class="form-wizard-step-icon"></div>-->
  <!--    <p>{{step}}</p>-->
  <!--  </div>-->
  <!--</div>-->

  <b-breadcrumb id="breadcrumbProgress" class="breadcrumb-wizard">
    <b-breadcrumb-item
      v-for="(step, index) in steps"
      :key="index"
      :id="'bread' + step.replace(/\s/g, '')"
      @click="goStep(index)"
      :active="index > value"
      class="cursor-pointer"
      >{{ step }}</b-breadcrumb-item
    >
  </b-breadcrumb>
</template>

<script>
export default {
  props: ["value", "steps"],
  methods: {
    goStep(index) {
      this.$emit("change", index);
    },
  },
};
</script>
